<template>
    <div class="h-100">
        <Header />
        <div
            class="tab-content content-height"
            :class="
                isMobile
                    ? 'suggestions-tab-content-mobile'
                    : 'suggestions-tab-content'
            "
            id="myTabContent"
        >
            <div
                class="tab-pane fade show active h-100"
                role="tabpanel"
                aria-labelledby="all-tab"
            >
                <div class="card">
                    <div class="card-body p-0">
                        <div
                            class="row m-0 w-100 align-items-center padding-l-10 padding-r-10 padding-t-10 justify-content-start filter-block"
                        >
                            <div v-if="selectedCategory?.value" @click="removeSelectedCategory" class="pointer d-flex align-items-center justify-content-center padding-b-20 padding-l-10 padding-t-10">
                                <svg  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.2069 10.4194L14.7931 5L16.5 6.65591L10.9138 12.0753L16.5 17.3441L14.7931 19L9.2069 13.7312L7.5 12.0753L9.2069 10.4194Z" fill="#006BE6"/>
                                </svg>
                            </div>
                            <SearchInput @handleSearch="handleSearch" />
                            <div class="padding-b-20 padding-r-10 padding-t-10 padding-l-10">
                              <button
                                type="button"
                                @click="() => {$router.push('/timeless-tenders/buy/add')}"
                                class="btn btn-primary"
                              >
                                <i class="fas fa-plus mr-2"></i>
                                <span>Ավելացնել անժամկետ տենդերներ</span>
                              </button>
                            </div>
                        </div>
                        <div class="row w-100 m-0">
                            <div class="col-12 tenders-list p-0">
                                <div class="d-flex flex-column padding-10">
                                    <div class="d-flex flex-wrap gap-2">
                                        <template v-if="hasSelectedCategory">
                                            <tender-card
                                                @click="
                                                $router.push(
                                                    `/timeless-tenders/sell/tender/${tender.id}`
                                                )
                                            "
                                                :tender="tender"
                                                :selectedType="'seller'"
                                                :can-edit="false"
                                                v-for="tender in tenders"
                                                :key="tender.id"
                                            />
                                        </template>
                                        <template v-else>
                                            <category-card
                                                :category="category"
                                                :selectedCategory="
                                                    selectedCategory
                                                "
                                                @clickMethod="
                                                    handleSelectCategory
                                                "
                                                :show-count="true"
                                                v-for="(category, index) in timelessTendersCategories.filter(cat => cat.count)"
                                                :key="index"
                                            />
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import isMobile from '@/mixins/isMobileView'
import Header from '../header.vue'
import TenderCard from '@/components/timelessTenders/tenderCard.vue'
import SearchInput from '@/components/timelessTenders/SearchInput.vue'
import CategoryCard from '@/components/timelessTenders/categoryCard.vue'

export default {
    components: { CategoryCard, SearchInput, TenderCard, Header },
    mixins: [isMobile],
    data() {
        return {
            dateNow: new Date(),
            backendUrl: process.env.VUE_APP_URL,
            tenders: [],
            allTenders: [],
            selectedCategory: {},
            categoryCounts: {},
            hasSelectedCategory: false,
            searchQuery: '',
            columns: [
                'password',
                'title',
                'products',
                'opening_finish_date',
                'price',
                'region',
                'type',
                'invitation',
                'edit',
                'participants_count',
            ],
        }
    },
    computed: {
        currentPlan() {
            return this.$store.getters['procurement/currentPlan']
        },
        locale() {
            return this.$store.getters['user/locale']
        },
        timelessTendersCategories() {
            const base = this.$store.getters['settings/timelessTendersCategories'];
            return base.map((category) => ({
                ...category,
                count: this.categoryCounts?.[category.value] || 0
            }));
        },
    },
    mounted() {
        this.getTenders()
    },
    methods: {
        handleSearch(query) {
            this.searchQuery = query
            this.getTenders()
        },
        getTenders() {
            this.$client
                .get('timeless-tenders', {
                    params: {
                        type: 'seller',
                        favorite: true,
                        category: this.selectedCategory?.value ?? '',
                        query: this.searchQuery,
                    },
                })
                .then(({ data }) => {
                    console.log('data', data)
                    if (!this.hasSelectedCategory) {
                        this.allTenders = data.data;
                        this.updateCategoryCounts();
                    } else {
                        this.tenders = data.data;
                    }
                })
                .finally(() => {
                    this.refreshTimelessMenuNotifications();
                });
        },
        updateCategoryCounts() {
            const counts = {};
            this.allTenders.forEach((tender) => {
                const category = tender.category;
                if (category) {
                    counts[category] = (counts[category] || 0) + 1;
                }
            });
            this.categoryCounts = counts;
        },
        handleSelectCategory(category) {
            if(category.count){
                this.selectedCategory = category
                this.hasSelectedCategory = true
                this.getTenders()
            }
        },
        removeSelectedCategory(){
            this.tenders = [];
            this.selectedCategory = {}
            this.hasSelectedCategory = false
        },
        refreshTimelessMenuNotifications() {
            this.$store.dispatch('user/getMenuNotifications')
        },
    },
}
</script>
